module.exports = __webpack_public_path__ + "img/package-active.d2923dd3.png";